import type { HubSection } from '@/components/Hub/hubSectionTypes';
import { spotlightSection } from '@/components/Hub/sections/spotlightSection';
import { storiesSection } from '@/components/Hub/sections/storiesSection';
import { librarySection } from '@/components/Hub/sections/librarySection';
import { lessonsSection } from '@/components/Hub/sections/lessonsSection';

// Never filter or reorder this at runtime. Each section owns a hook so the order has to hold.
export const HUB_SECTIONS: readonly HubSection[] = [spotlightSection, storiesSection, librarySection, lessonsSection];
